const copyToClipboard = (content) => {
    const inputGhost = document.createElement("input");
    document.body.appendChild(inputGhost);
    inputGhost.value = content;
    inputGhost.select();
    document.execCommand("copy");
    inputGhost.remove();
};

export default copyToClipboard;
